import { lazy } from "react";

const Relevebn = lazy(() => import("./Relevebn"));
const FacturesWrapper = lazy(() => import("./FacturesWrapper"));
const FacturesList = lazy(() => import("./FacturesList"));
const Operations = lazy(() => import("./Operations"));


const comptabiliteRoutes = [
  {
    path: "/comptabilite/releve",
    element: <Relevebn />,
  },
  {
    path: "/comptabilite/factures",
    element: <FacturesWrapper />,
  },
  {
    path: "/comptabilite/factures-list",
    element: <FacturesList />,
  },
  {
    path: "/comptabilite/Operations",
    element: <Operations />,
  },

];

export default comptabiliteRoutes;
